import { Outlet } from "react-router-dom";
import React from "react";
import { ApplicationScreen } from "../../components/top-level/screen/ApplicationScreen";

export function PublicAppRoot() {
    return <ApplicationScreen withUser={false}>
            <div className={"flex-1"}>
                <div className={"w-full flex flex-col min-h-content p-64"}>
                    <Outlet />
                </div>
            </div>
    </ApplicationScreen>;
}
